import React, { useContext, useEffect, useState } from 'react'
import { CSVLink } from 'react-csv'
import '../../App.css'
import UserView from './UserView'
import Menu from '../../components/UI/UIMenu'
import Modal from '../../components/UI/UIModal'
import UIButton from '../../components/UI/UIButton'
import UiSelect from '../../components/UI/UISelect'
import UITextInput from '../../components/UI/UITextInput'
import LineProgressBar from './components/LineProgressBar'
import { Icon } from '../../components/Icon'
import { useQuery, useQueryClient } from 'react-query'
import { getScrRecord, getSCRroles, User } from './apiCalls'
import { useToggledSwitches } from '../../context/ToggledSwitchesContext'
import Loading from '../../components/UI/Loading'

import {
  calculateNonNullPercentage,
  capitalizeFirstLetter,
  aggregateSafeguardingScore,
  aggregateTrainingScore,
} from '../../utils/utils'

import {
  createNote,
  createUserApi,
  deleteUser,
  resendVerificationEmail,
  updateUser,
} from '../../api/admin/scr'
import { toast } from 'react-toastify'
import {
  checkValidation,
  findLabelByValue,
  getScrHeaderConfig,
  getStoredIds,
  initialData,
  statusBgColor,
} from './utils'
import UIMultiSelect from '../../components/UI/UIMultiSelect'
import {
  exportToExcel,
  handleDownloadHtml,
  handleDownloadTxt,
} from '../policy/utils'
import { UIExportHtmlTable } from '../../components/UI/UIExportHtmlTable'
import UploadCSV from '../../components/UI/UploadCSV'
import { SidebarContext } from '../../context/SidebarContext'
import { ErrorResponse } from '../../utils/types'
import AddNoteModal from './components/AddNoteModal'
import ContactUserModal from './components/ContactUserModal'
import UISwitch from '../../components/UI/UISwitch'
import NestedCheckboxes from '../../components/UI/FilterData'
// import DataTable from '../../components/UI/DataTable'
interface createUser {
  firstName: string | null
  lastName: string | null
  email: string
  role: string
  schoolId?: string | undefined
  sendInvitationEmail: boolean
}

interface SelectedState {
  [parentCategoryId: string]: string[]
}

const EXPORT_CATEGORIES = [
  { label: 'Profile', value: 'profile' },
  { label: 'Safeguarding', value: 'safeguarding' },
  { label: 'Training', value: 'training' },
  { label: 'Policies', value: 'policies' },
]

const PROFILE_KEYS = [
  'email',
  'status',
  'schoolName',
  'role',
  'title',
  'firstName',
  'lastName',
  'dateOfBirth',
  'gender',
  'ethnicity',
  'disability',
  'businessContactNumber',
  'extensionNumber',
  'personalContactNumber',
  'businessEmail',
  'personalEmail',
  'addressLineOne',
  'addressLineTwo',
  'town',
  'country',
  'postCode',
  'e_contact_firstName',
  'e_contact_lastName',
  'e_contact_contactNumber',
  'e_contact_relationship',
  'e_contact_addressLineOne',
  'e_contact_addressLineTwo',
  'e_contact_town',
  'e_contact_country',
  'e_contact_postCode',
]

type ExportColumnKeys = 'profile' | 'safeguarding' | 'training' | 'policies'

const ComputeData = (records: User[], selectedValues: ExportColumnKeys[]) => {
  const duplicate: User[] = JSON.parse(JSON.stringify(records))

  const all_selected: string[] = ['firstName', 'lastName']

  selectedValues.forEach((i) => {
    if (i == 'profile') {
      PROFILE_KEYS.forEach((column) => {
        all_selected.push(column)
      })
    }
  })

  const data = duplicate.map((item) => {
    const filteredObj: Record<string, unknown> = {}

    selectedValues.forEach((field: ExportColumnKeys) => {
      filteredObj['firstName'] = item['firstName']
      filteredObj['lastName'] = item['lastName']
      if (field == 'profile') {
        PROFILE_KEYS.forEach((name) => {
          if (name in item) {
            filteredObj[name] = item[name as keyof typeof item]
          }
        })
      }

      if (field == 'safeguarding') {
        const Categories = item.safeguardingRecordCategory
        const categoryWithTitle = item.safeguardingRecords
          .map((safeguardingRecord) => {
            const category = Categories.find(
              (i) => i.id == safeguardingRecord.safeguardingRecordCategoryId
            )

            if (!category) return null

            safeguardingRecord.safeguardingRecordCategoryId = category.title

            return safeguardingRecord
          })
          .filter((i) => !!i)

        const Don_tIncludes = [
          'safeguardId',
          'safeguardingRecordCategoryId',
          'document',
          'riskDocument',
          'verifiedBy',
        ]

        categoryWithTitle.forEach((record) => {
          const copyRecord = { ...record }
          // @ts-expect-error emergency
          delete copyRecord.comments
          Object.keys(copyRecord).forEach((key) => {
            if (Don_tIncludes.includes(key)) return
            let recordKey = key
            if (recordKey == 'firstName') {
              recordKey = 'verifiedBy'
            }

            const newKey = `safeguarding_${record?.safeguardingRecordCategoryId}_${recordKey}`
            if (!all_selected.includes(newKey)) {
              all_selected.push(newKey)
            }
            if (
              ['expiryDate', 'verificationDate', 'issueDate'].includes(
                recordKey
              )
            ) {
              return (filteredObj[newKey] = // @ts-expect-error emergency
                ((record[key] || '') as string).split('T')[0])
            }
            // @ts-expect-error emergency
            filteredObj[newKey] = record[key] || null
          })
        })
      }
      if (field == 'training') {
        const Categories = item.trainingRecordCategory
        const categoryWithTitle = item.trainingRecords
          .map((trainingRecords) => {
            const category = Categories.find(
              (i) => i.id == trainingRecords.trainingRecordCategoryId
            )

            if (!category) return null

            trainingRecords.trainingRecordCategoryId = category.title

            return trainingRecords
          })
          .filter((i) => !!i)

        const Don_tIncludes = [
          'trainingId',
          'trainingRecordCategoryId',
          'schoolId',
          'duration',
          'riskDocument',
          'certificate',
          'verifiedBy',
        ]
        categoryWithTitle.forEach((record) => {
          const copyRecord = { ...record }

          delete copyRecord?.comments
          Object.keys(copyRecord).forEach((key) => {
            if (Don_tIncludes.includes(key)) return
            let recordKey = key
            if (recordKey == 'firstName') {
              recordKey = 'verifiedBy'
            }
            const newKey = `training_${record?.trainingRecordCategoryId}_${recordKey}`
            if (!all_selected.includes(newKey)) {
              all_selected.push(newKey)
            }

            if (['expiryDate', 'verificationDate'].includes(recordKey)) {
              return (filteredObj[newKey] = // @ts-expect-error emergency
                ((record[key] || '') as string).split('T')[0])
            }
            // @ts-expect-error emergency2
            filteredObj[newKey] = record[key] || null
          })
        })
      }

      if (field == 'policies') {
        const Policies = item.Policies

        Policies.forEach((p) => {
          const newKey = `policy_${p.title}_agreement`
          if (!all_selected.includes(newKey)) {
            all_selected.push(newKey)
          }

          const policyAgreement = item.userPolicyAgreements.find(
            (i) => i.policyId == p.policyId
          )
          filteredObj[newKey] = (
            (policyAgreement?.createdAt || '') as string
          ).split('T')[0]
        })
      }
    })
    return filteredObj
  })

  return { data, all_selected }
}

const CenteralRecords = () => {
  const { toggledSwitches, schoolId } = useToggledSwitches()
  const { view, setView } = useContext(SidebarContext)

  const schoolIds = getStoredIds('SchoolIds')

  const queryClient = useQueryClient()

  const [isExportOpen, setIsExportOpen] = useState<boolean>(false)
  const [isConfrim, setIsConfrim] = useState<boolean>(false)
  const [fileType, setFileType] = useState<string>('')
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [formData, setFormData] = useState<createUser>(initialData)

  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('firstName')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')
  const [isEditUserModalOpen, setIsEditUserModalOpen] = useState<boolean>(false)
  const [isEditUserLoading, setIsEditUserLoading] = useState<boolean>(false)
  const [isOpenAddNotesModal, setIsOpenAddNotesModal] = useState<boolean>(false)
  const [notesDetail, setNotesDetail] = useState<string>('')
  const [notesTitle, setNotesTitle] = useState<string>('')
  const [addNotesLoading, setAddNotesLoading] = useState<boolean>(false)

  const [isOpenContactModal, setIsOpenContactModal] = useState<boolean>(false)
  const [selectedValues, setSelectedValues] = useState<ExportColumnKeys[]>([])

  const [activeTab, setActiveTab] = useState<string>('tab1')
  const [filtered, setFiltered] = useState<User[]>([])

  const scrRecords = useQuery(
    'scr',
    () =>
      getScrRecord(
        toggledSwitches.length > 0 ? toggledSwitches : schoolIds,
        currentPage,
        sortBy,
        sortOrderValue,
        activeTab
      ),
    {
      enabled: false,
    }
  )

  const handleGetFilteredValue = (selected: SelectedState) => {
    let MyData: User[] = scrRecords?.data?.data || []

    // Filter for all_360
    if (selected?.['all_360'] && selected['all_360'].length > 0) {
      if (!selected['all_360'].includes('all_child_360')) {
        MyData = MyData.filter((user) =>
          selected['all_360'].includes(user.roleId)
        )
      }
    }

    // Filter for safeguarding
    if (selected?.['safeguarding'] && selected['safeguarding'].length > 0) {
      if (!selected['safeguarding'].includes('all_safeguard')) {
        const filteredSafeguarding = MyData.filter((user) =>
          user.safeguardingRecords?.some((record) =>
            selected['safeguarding'].includes(
              record.safeguardingRecordCategoryId
            )
          )
        )

        // Only update MyData if we have matches
        if (filteredSafeguarding.length > 0) {
          MyData = filteredSafeguarding
        }
      }
    }

    // Filter for training
    if (selected?.['training'] && selected['training'].length > 0) {
      if (!selected['training'].includes('all_training')) {
        const filteredTraining = MyData.filter((user) =>
          user.trainingRecords?.some((record) =>
            selected['training'].includes(record.trainingRecordCategoryId)
          )
        )

        // Only update MyData if we have matches
        if (filteredTraining.length > 0) {
          MyData = filteredTraining
        }
      }
    }
    setFiltered(MyData) // Update the filtered state with the new data
  }

  // const handleGetFilteredValue = (selected: SelectedState) => {
  //   // const MyData: User[] = []
  //   let MyData: User[] = scrRecords?.data?.data || []

  //   const findTemp = selected

  //   if (findTemp?.['all_360']) {
  //     if (findTemp?.['all_360'].includes('all_child_360')) {
  //       MyData
  //     } else {
  //       MyData =
  //         MyData?.filter((i) => findTemp?.['all_360'].includes(i.roleId)) || []
  //       // MyData.push(...data)
  //     }
  //   }
  //   if (findTemp?.['safeguarding']) {
  //     if (findTemp?.['safeguarding'].includes('all_safeguard')) {
  //       MyData
  //     } else {
  //       // const data = scrRecords?.data?.data
  //       MyData?.map((i) => i)
  //       MyData = MyData?.filter((i) => {
  //         return i.safeguardingRecords.find((record) =>
  //           findTemp?.['safeguarding'].includes(
  //             record.safeguardingRecordCategoryId
  //           )
  //         )
  //       })
  //       // if (temp) {
  //       //   MyData.push(...temp)
  //       // }
  //     }
  //   }
  //   if (findTemp?.['training']) {
  //     if (findTemp?.['training'].includes('all_training')) {
  //       // const data = scrRecords?.data?.data || []
  //       // MyData.push(...data)
  //       MyData
  //     } else {
  //       // const data = scrRecords?.data?.data
  //       MyData?.map((i) => i)
  //       MyData = MyData?.filter((i) => {
  //         return i.trainingRecords.find((record) =>
  //           findTemp?.['training'].includes(record.trainingRecordCategoryId)
  //         )
  //       })
  //       // if (temp) {
  //       //   MyData.push(...temp)
  //       // }
  //     }
  //   }
  //   console.log('MyData', MyData)
  // }

  const handleSelectionChange = (selected: string[]) => {
    setSelectedValues(selected as ExportColumnKeys[])
  }
  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    scrRecords.refetch() // Refetch incidents when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  useEffect(() => {
    setIsView(view)
  }, [view])

  const handleExportOpenModal = () => {
    setIsExportOpen(true)
  }

  const handleExportCloseModal = () => {
    setIsExportOpen(false)
  }

  const [id, setId] = useState('')
  const [schoolItemId, setSchoolItemId] = useState('')
  const [isView, setIsView] = useState<string>(view)
  const [isOpenDeleteUserModal, setIsOpenDeleteUserModal] =
    useState<boolean>(false)
  const [isFilterFieldsModalOpen, setIsFilterFieldsModalOpen] =
    useState<boolean>(false)
  const [isCreateGroupModalOpen, setIsCreateGroupModalOpen] =
    useState<boolean>(false)
  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(scrRecords?.data?.data?.length || 100).fill(false)
  )
  const [currentPage, setCurrentPage] = useState<number>(1)

  const scrHeader = getScrHeaderConfig(activeTab)
  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
    queryClient.fetchQuery('role')
  }

  const handleCloseModal = () => {
    setIsOpen(false)
  }

  const roles = useQuery('role', () => getSCRroles())

  useEffect(() => {
    scrRecords.refetch()
    setCurrentPage(1)
  }, [currentPage, activeTab])

  useEffect(() => {
    scrRecords.refetch()
  }, [toggledSwitches])

  const handleChange = (fieldName: string, value: string | boolean): void => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const rolesData = roles?.data?.map((item) => ({
    value: item.id,
    label: item.role,
  }))

  const addUser = async (): Promise<void> => {
    try {
      const response = (await createUserApi({
        ...formData,
        schoolId: schoolId,
      })) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        handleCloseModal()
        setFormData(initialData)
        toast.success('User Created.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const removeUser = async (): Promise<void> => {
    try {
      const response = (await deleteUser({ id: id })) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        setIsOpenDeleteUserModal(false)
        toast.success('User Deleted', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  const EditUser = async (): Promise<void> => {
    const { role, schoolId, firstName, lastName } = formData
    const newData = { role, schoolId, firstName, lastName }
    setIsEditUserLoading(true)
    try {
      const response = (await updateUser(newData, id)) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        setIsEditUserModalOpen(false)
        toast.success('User Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    } finally {
      setIsEditUserLoading(false)
    }
  }

  const addNote = async (): Promise<void> => {
    setAddNotesLoading(true)
    try {
      const response = (await createNote(
        notesTitle,
        schoolItemId,
        notesDetail,
        id
      )) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        setIsOpenAddNotesModal(false)
        queryClient.invalidateQueries('Noters')
        toast.success('Note added', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while adding note.', {
        position: 'top-right',
      })
    } finally {
      setAddNotesLoading(false)
    }
  }

  const resendEmail = async (uid: string): Promise<void> => {
    setAddNotesLoading(true)
    try {
      const response = (await resendVerificationEmail(uid)) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        queryClient.fetchQuery('scr')
        setIsOpenAddNotesModal(false)
        queryClient.invalidateQueries('Noters')
        toast.success('Email Sent', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while sending email.', {
        position: 'top-right',
      })
    } finally {
      setAddNotesLoading(false)
    }
  }

  const handleSwitchChange = (value: boolean) => {
    handleChange('sendInvitationEmail', value)
  }

  return (
    <>
      {isView == 'centeral-records' && (
        <div
          className={
            'flex flex-col gap-6 w-full bg-white  h-full rounded-3xl p-8 overflow-hidden'
          }
        >
          <div className="flex flex-col gap-6 w-full relative h-full ">
            <div className={'flex w-full justify-between items-start '}>
              <div className="flex-col w-[auto] gap-[20px]">
                <p className={'text-lg leading-5 font-bold text-text2'}>
                  Single Central Records
                </p>
              </div>
              <div className={'flex flex-row gap-[5px]'}>
                <div
                  onClick={() => {
                    setIsFilterFieldsModalOpen(true)
                  }}
                  className="gap-3 bg-bluishGreen items-center justify-between text-white px-5 py-2 flex rounded-[72px] cursor-pointer"
                >
                  <p className={'font-semibold text-sm leading-6 text-white'}>
                    Filter Fields
                  </p>
                  <Icon
                    name={'IconShare'}
                    strokeWidth={1.2}
                    stroke={'#FFFFFF'}
                    width={16}
                    height={16}
                  />
                </div>
                <div
                  onClick={() => setIsCreateGroupModalOpen(true)}
                  className="gap-2 bg-transparent border border-gray2 items-center justify-between text-white px-5 py-2 flex rounded-[72px] cursor-pointer"
                >
                  <p className={'font-semibold text-sm leading-6 text-text1'}>
                    Import Users
                  </p>
                  <Icon
                    name={'IconPlus'}
                    strokeWidth={1}
                    stroke={'#02698C'}
                    width={16}
                    height={16}
                  />
                </div>
                <div
                  onClick={handleOpenModal}
                  className="gap-2 bg-gray2 items-center justify-between text-white px-5 py-2 flex rounded-[72px] cursor-pointer"
                >
                  <p className={'font-semibold text-sm leading-6 text-text1'}>
                    Add User
                  </p>
                  <Icon
                    name={'IconPlus'}
                    strokeWidth={1}
                    stroke={'#02698C'}
                    width={16}
                    height={16}
                  />
                </div>
                <div
                  onClick={() => {
                    if (scrRecords?.data?.data?.length != 0) {
                      handleExportOpenModal()
                    } else {
                      toast.info('No data available.', {
                        position: 'top-right',
                      })
                    }
                  }}
                  className="gap-3 bg-bluishGreen items-center justify-between text-white px-5 py-2 flex rounded-[72px] cursor-pointer"
                >
                  <p className={'font-semibold text-sm leading-6 text-white'}>
                    Export Data
                  </p>
                  <Icon
                    name={'IconShare'}
                    strokeWidth={1.2}
                    stroke={'#FFFFFF'}
                    width={16}
                    height={16}
                  />
                </div>
              </div>
            </div>
            <div className="flex w-[100%] space-x-4">
              <button
                className={`rounded-[72px]  w-[50%] px-4 py-2 font-semibold ${activeTab === 'tab1' ? 'bg-bluishGreen text-white' : 'bg-gray2 text-bluishGreen'}`}
                onClick={() => setActiveTab('tab1')}
              >
                All
              </button>
              <button
                className={`rounded-[72px] w-[50%] px-4 py-2 font-semibold ${activeTab === 'tab2' ? 'bg-bluishGreen text-white' : 'bg-gray2 text-bluishGreen'}`}
                onClick={() => setActiveTab('tab2')}
              >
                Archived
              </button>
            </div>

            <div className="relative h-full overflow-y-auto">
              <div className=" max-h-full h-full overflow-y-auto">
                {scrRecords.isLoading && (
                  <div className="flex-col  w-[100%] p-[10px]">
                    <Loading size="large" />
                  </div>
                )}
                {!scrRecords.isLoading && (
                  <table className="min-w-full table-auto divide-y-4 divide-white">
                    <thead className="sticky top-0 z-10 mb-4">
                      <tr className="bg-gray2 rounded-lg h-10 mb-18">
                        {scrHeader?.map((i, index) => (
                          <th
                            onClick={() => {
                              handleSort(i.key)
                            }}
                            key={index}
                            className={`px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${index === scrHeader.length - 1 ? 'border-none' : 'border-r border-white'}`}
                          >
                            <div
                              className={`flex items-center justify-between text-sm font-semibold leading-6 text-text1 cursor-pointer ${i.display == false ? 'hidden' : ''} `}
                            >
                              {i.heading}
                              <div
                                className={` ${i.icon == true ? 'flex' : 'hidden'} `}
                              >
                                <Icon
                                  name={'IconChevronDown'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1}
                                  stroke={'#67A5B9'}
                                />
                              </div>
                            </div>
                          </th>
                        ))}
                        <th className="w-[56px] rounded-r-lg"></th>
                      </tr>
                    </thead>
                    <tbody className="bg-white pt-72 divide-y-4 divide-white">
                      {scrRecords?.data?.data?.map((item, index) => (
                        <tr
                          key={item.userId}
                          className="table-row max-h-10 bg-gray1"
                        >
                          <td
                            onClick={() => {
                              queryClient.fetchQuery('role')
                              setIsView('user-view')
                              setView('user-view')
                              setId(item.userId)
                              setSchoolItemId(item.schoolId)
                              // handleToggleMenu(index)
                            }}
                            className="px-4 py-2 rounded-l-lg border-r border-white"
                          >
                            <div className="flex items-center gap-3">
                              <div className="flex items-center justify-center rounded-full bg-bluishGreen text-white w-10 h-10 border-4 border-[#FFFFFF33]">
                                {item?.profileImageUrl?.includes('h') ? (
                                  <img
                                    src={item.profileImageUrl}
                                    width={32}
                                    height={32}
                                    alt="Profile"
                                    className="rounded-full bg-transparent object-cover border-none w-8 h-8"
                                  />
                                ) : (
                                  <p className="text-xs text-white font-medium">
                                    {item.firstName?.charAt(0)?.toUpperCase()}{' '}
                                    {item.lastName?.charAt(0)?.toUpperCase()}
                                  </p>
                                )}
                              </div>
                              <p className="text-sm font-semibold leading-6 text-text2">
                                {capitalizeFirstLetter(item.firstName || '')}{' '}
                                {capitalizeFirstLetter(item.lastName || '')}
                              </p>
                            </div>
                          </td>
                          <td className="px-4 w-[150px] py-2 border-r border-white">
                            <div className="rounded-[40px] w-fit bg-gray3 p-2 px-3">
                              <p className="text-xs font-medium leading-5 text-bluishGreen">
                                {item.role}
                              </p>
                            </div>
                          </td>
                          <td className="px-4 py-2 border-r w-[200px]  border-white">
                            <LineProgressBar
                              percentage={
                                calculateNonNullPercentage([
                                  item?.firstName,
                                  item?.lastName,
                                  item?.dateOfBirth,
                                  item?.gender,
                                  item?.ethnicity,
                                  item?.disability,
                                  item?.businessContactNumber,

                                  item?.personalContactNumber,
                                  item?.businessEmail,
                                  item?.addressLineOne,

                                  item?.town,
                                  item?.country,
                                  item?.postCode,
                                  item?.e_contact_firstName,
                                  item?.e_contact_lastName,
                                  item?.e_contact_contactNumber,
                                  item?.e_contact_relationship,
                                  item?.e_contact_addressLineOne,

                                  item?.e_contact_town,
                                  item?.e_contact_country,
                                  item?.e_contact_postCode,
                                ])?.percentage
                              }
                              stroke={
                                calculateNonNullPercentage([
                                  item?.firstName,
                                  item?.lastName,
                                  item?.dateOfBirth,
                                  item?.gender,
                                  item?.ethnicity,
                                  item?.disability,
                                  item?.businessContactNumber,

                                  item?.personalContactNumber,
                                  item?.businessEmail,
                                  item?.addressLineOne,

                                  item?.town,
                                  item?.country,
                                  item?.postCode,
                                  item?.e_contact_firstName,
                                  item?.e_contact_lastName,
                                  item?.e_contact_contactNumber,
                                  item?.e_contact_relationship,
                                  item?.e_contact_addressLineOne,

                                  item?.e_contact_town,
                                  item?.e_contact_country,
                                  item?.e_contact_postCode,
                                ])?.color
                              }
                              strokeWidth={1.5}
                            />
                          </td>
                          <td className="px-4 py-2 border-r w-[200px]  border-white">
                            <LineProgressBar
                              percentage={
                                aggregateSafeguardingScore(
                                  item?.safeguardingRecordCategory,
                                  item?.safeguardingRecords
                                ).percentage
                              }
                              stroke={
                                aggregateSafeguardingScore(
                                  item?.safeguardingRecordCategory,
                                  item?.safeguardingRecords
                                ).color
                              }
                              strokeWidth={1.5}
                            />
                          </td>
                          <td className="px-4 py-2 border-r w-[200px]  border-white">
                            <LineProgressBar
                              percentage={
                                aggregateTrainingScore(
                                  item?.trainingRecordCategory,
                                  item?.trainingRecords
                                ).percentage
                              }
                              stroke={
                                aggregateTrainingScore(
                                  item?.trainingRecordCategory,
                                  item?.trainingRecords
                                ).color
                              }
                              strokeWidth={1.5}
                            />
                          </td>
                          <td className={`px-4 py-2 w-[100px] `}>
                            <div
                              className={`w-fit rounded-[40px] bg-${statusBgColor(item?.status)} ${activeTab == 'tab2' ? 'hidden' : ''}  p-2 px-3 flex-1`}
                            >
                              <p className="text-xs font-medium leading-5 text-bluishGreen">
                                {capitalizeFirstLetter(item?.status)}
                              </p>
                            </div>
                          </td>
                          <td className="px-4 py-2 space-x-2 rounded-r-lg h-full justify-center items-center">
                            <Menu
                              isOpen={isOpenMenu[index]}
                              items={[
                                {
                                  label: 'View',
                                  onClick: () => {
                                    queryClient.fetchQuery('role')
                                    setIsView('user-view')
                                    setView('user-view')
                                    setId(item.userId)
                                    setSchoolItemId(item.schoolId)
                                    handleToggleMenu(index)
                                  },

                                  icon: 'IconEye',
                                  iconColor: '#02698C',
                                },
                                {
                                  display:
                                    item.status == 'inactive' ? true : false,
                                  label: 'Re-send verification',
                                  onClick: () => {
                                    resendEmail(item.userId)
                                    setId(item.userId)
                                  },
                                  icon: 'IconMail',
                                  iconColor: '#02698C',
                                },
                                {
                                  label: 'Contact',
                                  onClick: () => {
                                    setIsOpenContactModal(true)
                                    // setContactEmail(item.email)
                                  },
                                  icon: 'IconMail',
                                  iconColor: '#02698C',
                                },
                                {
                                  label: 'Add Note',
                                  onClick: () => {
                                    setIsOpenAddNotesModal(!isOpenAddNotesModal)
                                    setSchoolItemId(item.schoolId)
                                    setId(item.userId)
                                  },
                                  icon: 'IconStickerSquare',
                                  iconColor: '#02698C',
                                },
                                {
                                  label: 'Remove',
                                  onClick: () => {
                                    setIsOpenDeleteUserModal(true)
                                    setSchoolItemId(item.schoolId)
                                    setId(item.userId)
                                  },
                                  icon: 'IconTrash',
                                  iconColor: '#FF6666',
                                  textColor: 'text-textError',
                                },
                              ]}
                              setIsOpenMenu={setIsOpenMenu}
                              isOpenMenus={isOpenMenu}
                            >
                              <div
                                className="cursor-pointer"
                                onClick={() => handleToggleMenu(index)}
                              >
                                <Icon
                                  name={'IconDotsVertical'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1.5}
                                  stroke={'#02698C'}
                                />
                              </div>
                            </Menu>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
          {/* Add Notes Modal */}
          <AddNoteModal
            isOpen={isOpenAddNotesModal}
            onClose={() => setIsOpenAddNotesModal(false)}
            notesDetail={notesDetail}
            setNotesDetail={setNotesDetail}
            notesTitle={notesTitle}
            setNotesTitle={setNotesTitle}
            addNote={addNote}
            loading={addNotesLoading}
          />
          {/* Add Contact Modal */}
          <ContactUserModal
            isOpen={isOpenContactModal}
            onClose={() => setIsOpenContactModal(false)}
          />

          {/* Edit User Modal */}
          <Modal
            customStyle={{ borderRadius: 16, width: '480px' }}
            isOpen={isEditUserModalOpen}
            onClose={() => setIsEditUserModalOpen(false)}
          >
            <div
              className={
                'max-h-[80vh] overflow-scroll custom-scrollbar items-center px-4 py-2  flex flex-col gap-4'
              }
            >
              <div
                onClick={() => setIsEditUserModalOpen(false)}
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name={'IconUserPlus'}
                  stroke="#02698C"
                  height={52}
                  width={52}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
                <p className={'text-text2 text-lg font-bold leading-6'}>
                  Edit User
                </p>
                <p className={'text-sm text-text1 font-normal leading-6'}>
                  Please update the details of the user you would like
                </p>
              </div>
              <div className="flex">
                <div className="w-6/12 mr-3">
                  <UITextInput
                    value={formData?.firstName || ''}
                    label={'First Name*'}
                    onChange={(e) => {
                      handleChange('firstName', e.target.value)
                    }}
                    onBlur={() => {}}
                    placeholder="First Name"
                    iconName={'none'}
                    inputCustomClass="font-semibold"
                  />
                </div>
                <div className="w-6/12 ml-1">
                  <UITextInput
                    value={formData?.lastName || ''}
                    label={'Last Name*'}
                    onChange={(e) => {
                      handleChange('lastName', e.target.value)
                    }}
                    onBlur={() => {}}
                    placeholder="Last Name"
                    iconName={'none'}
                    inputCustomClass="font-semibold"
                  />
                </div>
              </div>
              <div className="w-full">
                <UITextInput
                  readOnly={true}
                  value={formData?.email || ''}
                  label={'Email Address*'}
                  onChange={(e) => {
                    handleChange('email', e.target.value)
                  }}
                  onBlur={() => {}}
                  placeholder="Email Address"
                  iconName={'none'}
                  inputCustomClass="font-semibold"
                />
              </div>
              <div className="w-full">
                <UiSelect
                  title={'Role*'}
                  placeholder={
                    findLabelByValue(formData?.role, rolesData || []) || ''
                  }
                  options={rolesData ? rolesData : []}
                  onChange={(e) => {
                    handleChange('role', e)
                  }}
                />
              </div>
              <div className="w-full mt-4">
                <UIButton
                  loading={isEditUserLoading}
                  label={'Update'}
                  onClick={() => {
                    EditUser()
                  }}
                />
              </div>
            </div>
          </Modal>
          {/* Create User Modal */}
          <Modal
            customStyle={{ borderRadius: 16, width: '480px' }}
            isOpen={isOpen}
            onClose={handleCloseModal}
          >
            <div
              className={
                'max-h-[80vh] overflow-scroll custom-scrollbar items-center px-4 py-2  flex flex-col gap-4'
              }
            >
              <div
                onClick={handleCloseModal}
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name={'IconUserPlus'}
                  stroke="#02698C"
                  height={52}
                  width={52}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
                <p className={'text-text2 text-lg font-bold leading-6'}>
                  Add User
                </p>
                <p className={'text-sm text-text1 font-normal leading-6'}>
                  Please enter the details of the user you would like to add
                </p>
              </div>
              <div className="flex">
                <div className="w-6/12 mr-3">
                  <UITextInput
                    label={'First Name*'}
                    onChange={(e) => {
                      handleChange('firstName', e.target.value)
                    }}
                    value={formData.firstName ? formData.firstName : ''}
                    onBlur={() => {}}
                    placeholder="First Name"
                    iconName={'none'}
                    inputCustomClass="font-semibold"
                  />
                </div>
                <div className="w-6/12 ml-1">
                  <UITextInput
                    label={'Last Name*'}
                    onChange={(e) => {
                      handleChange('lastName', e.target.value)
                    }}
                    value={formData.lastName ? formData.lastName : ''}
                    onBlur={() => {}}
                    placeholder="Last Name"
                    iconName={'none'}
                    inputCustomClass="font-semibold"
                  />
                </div>
              </div>
              <div className="w-full">
                <UITextInput
                  label={'Email Address*'}
                  onChange={(e) => {
                    handleChange('email', e.target.value)
                  }}
                  value={formData.email}
                  onBlur={() => {}}
                  placeholder="Email Address"
                  iconName={'none'}
                  inputCustomClass="font-semibold"
                />
              </div>
              <div className="w-full">
                <UiSelect
                  title={'Role*'}
                  placeholder="Please specify"
                  onChange={(e) => {
                    handleChange('role', e)
                  }}
                  value={formData.role}
                  options={rolesData || []}
                />
              </div>
              <div className="w-full p-4 bg-gray1 rounded-xl flex">
                <div className="flex-1">
                  <p className="text-sm font-semibold leading-6 text-text4">
                    Verification Email
                  </p>
                </div>
                <div>
                  <UISwitch
                    value={formData?.sendInvitationEmail}
                    onValueChange={handleSwitchChange}
                  />
                </div>
              </div>
              <div className="w-full mt-4">
                <UIButton
                  disabled={checkValidation(formData)}
                  label={'Create'}
                  onClick={() => {
                    addUser()
                  }}
                />
              </div>
            </div>
          </Modal>
          {/* Create group Modal  */}
          <Modal
            customStyle={{ borderRadius: 16, width: '600px' }}
            isOpen={isCreateGroupModalOpen}
            onClose={() => setIsCreateGroupModalOpen(!isCreateGroupModalOpen)}
          >
            <div
              className={
                'max-h-[80vh] overflow-scroll custom-scrollbar w-[100%] items-center px-4 py-2  flex flex-col gap-4'
              }
            >
              <div
                onClick={() =>
                  setIsCreateGroupModalOpen(!isCreateGroupModalOpen)
                }
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name={'IconFolderPlus'}
                  stroke="#02698C"
                  height={52}
                  width={52}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
                <p className={'text-text2 text-lg font-bold leading-6'}>
                  Upload Data
                </p>
              </div>
              <UploadCSV />
            </div>
          </Modal>
          <Modal
            customStyle={{ borderRadius: 16, padding: 20, width: 480 }}
            isOpen={isOpenDeleteUserModal}
            onClose={() => setIsOpenDeleteUserModal(false)}
          >
            <div
              className={'max-h-[80vh] items-center p-4 flex flex-col gap-4'}
            >
              <div
                onClick={() => setIsOpenDeleteUserModal(false)}
                className="flex w-[100%] justify-end cursor-pointer"
              >
                <Icon
                  name={'IconCross'}
                  stroke="#02698C"
                  height={16}
                  width={16}
                />
              </div>
              <div className="flex items-center w-[100%] justify-center">
                <Icon
                  name="IconAlertTriangle"
                  stroke={'#FF6666'}
                  strokeWidth={0.6}
                  height={52}
                  width={52}
                />
              </div>
              <div className="flex flex-col gap-2 items-center w-[100%] justify-center mb-4">
                <h1 className={'text-text2 text-lg font-bold leading-6'}>
                  Remove User
                </h1>
                <p className={'text-sm text-text1 font-normal leading-6'}>
                  Are you sure you want to remove this user?
                </p>
              </div>
              <div className="w-full flex flex-col gap-4">
                <button
                  onClick={() => {
                    removeUser()
                  }}
                  className="text-textError border-textError border-[1px] min-h-[48px] font-medium rounded-[72px] text-[14px]"
                >
                  Yes, I’m sure
                </button>
                <button
                  onClick={() => setIsOpenDeleteUserModal(false)}
                  className="text-text1 border-textError bg-gray2 min-h-[48px] font-medium rounded-[72px] text-[14px]"
                >
                  Cancel
                </button>
              </div>
            </div>
          </Modal>
          {/************************************* Filter modal ************************************/}
          <Modal
            // customStyle={{ borderRadius: 0, height: 'auto', width: '500px' }}
            customStyle={{
              borderRadius: 16,
              padding: '16px 8px',
              width: '480px',
            }}
            isOpen={isFilterFieldsModalOpen}
            onClose={() => setIsFilterFieldsModalOpen(!isFilterFieldsModalOpen)}
          >
            {isConfrim ? (
              <div
                className={
                  'max-h-[100vh] custom-scrollbar items-center flex flex-col gap-4 py-4 px-8'
                }
              >
                <div
                  onClick={handleExportCloseModal}
                  className="flex w-[100%] justify-end cursor-pointer"
                >
                  <Icon
                    name={'IconCross'}
                    stroke="#02698C"
                    height={16}
                    width={16}
                  />
                </div>
                <div className="flex items-center w-[100%] justify-center">
                  <Icon
                    name={'IconExportData'}
                    height={52}
                    width={52}
                    strokeWidth={1}
                    stroke="#02698C"
                  />
                </div>
                <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
                  <h1 className={'text-text2 text-lg font-bold leading-6'}>
                    Export Data
                  </h1>
                  <p
                    className={
                      'text-sm text-text1 font-normal leading-6 text-center'
                    }
                  >
                    The CSV export file will be generated for download. Disable
                    any popup blockers in your browser to ensure proper
                    download. <span className="mt-3">Ok to proceed?</span>
                  </p>
                  <p
                    className={
                      'text-sm text-text1 font-normal leading-6 mt-4 text-center'
                    }
                  >
                    Ok to proceed?
                  </p>
                </div>
                <div className="w-full flex flex-col gap-2 mt-2">
                  {(fileType == 'Excel95' || fileType == 'Excel2007') && (
                    <UIButton
                      label="Confirm"
                      onClick={() => {
                        const { data } = ComputeData(filtered || [], [
                          'profile',
                          'safeguarding',
                          'training',
                          'policies',
                        ])

                        if (data.length) {
                          exportToExcel(data, 'data', fileType)
                        }

                        // exportToExcel(scrRecords?.data?.data, 'data', fileType)
                        handleExportCloseModal()
                        setIsConfrim(!isConfrim)
                        setIsFilterFieldsModalOpen(false)
                        setSelectedValues([])
                      }}
                    />
                  )}
                  {fileType == 'HTML' && (
                    <UIButton
                      label="Confirm"
                      onClick={() => {
                        const { all_selected, data } = ComputeData(
                          filtered || [],
                          ['profile', 'safeguarding', 'training', 'policies']
                        )

                        const columns: { title: string; column: string }[] = []

                        all_selected.forEach((val) => {
                          columns.push({ title: val, column: val })
                        })

                        const html = UIExportHtmlTable({
                          columns,
                          data,
                        })
                        if (html) {
                          setIsFilterFieldsModalOpen(false)
                          handleDownloadHtml(html)
                          handleExportCloseModal()
                          setIsConfrim(!isConfrim)
                          setSelectedValues([])
                        }
                      }}
                    />
                  )}
                  {fileType == 'Text' && (
                    <UIButton
                      label="Confirm"
                      onClick={() => {
                        const { data } = ComputeData(filtered || [], [
                          'profile',
                          'safeguarding',
                          'training',
                          'policies',
                        ])
                        setIsFilterFieldsModalOpen(false)
                        handleDownloadTxt(data)
                        handleExportCloseModal()
                        setIsConfrim(!isConfrim)
                        setSelectedValues([])
                      }}
                    />
                  )}
                  {fileType == 'CSV' && (
                    <CSVLink
                      target="_blank"
                      filename={'data.csv'}
                      headers={(() => {
                        const { all_selected } = ComputeData(filtered || [], [
                          'profile',
                          'safeguarding',
                          'training',
                          'policies',
                        ])

                        const headers: {
                          key: string
                          label: string
                        }[] = []

                        all_selected.forEach((val) => {
                          headers.push({ key: val, label: val })
                        })

                        return headers
                      })()}
                      data={(() => {
                        const { data } = ComputeData(filtered || [], [
                          'profile',
                          'safeguarding',
                          'training',
                          'policies',
                        ])

                        return data
                      })()}
                    >
                      <UIButton
                        label="Confirm"
                        onClick={() => {
                          setIsFilterFieldsModalOpen(false)
                          handleExportCloseModal()
                          setIsConfrim(!isConfrim)
                          setSelectedValues([])
                        }}
                      />
                    </CSVLink>
                  )}
                  <UIButton
                    secondary
                    label="Cancel"
                    onClick={() => setIsConfrim(!isConfrim)}
                  />
                </div>
              </div>
            ) : (
              <div
                className={
                  ' custom-scrollbar w-[100%] items-start  py-2 px-2  flex flex-col gap-4'
                }
              >
                <div
                  onClick={() =>
                    setIsFilterFieldsModalOpen(!isFilterFieldsModalOpen)
                  }
                  className="flex w-[100%] justify-end cursor-pointer"
                >
                  <Icon
                    name={'IconCross'}
                    stroke="#02698C"
                    height={16}
                    width={16}
                  />
                </div>
                <NestedCheckboxes getValue={handleGetFilteredValue} />
                <div className="w-[100%] flex-col flex gap-4 ">
                  <UiSelect
                    title={'Choose Filetype'}
                    placeholder="Please specify"
                    labelClass={'text-xs'}
                    onChange={(value) => setFileType(value)}
                    selectedOptionClass={
                      'text-sm font-semibold leading-6 text-text4'
                    }
                    options={[
                      {
                        value: 'HTML',
                        label: 'HTML',
                        iconName: 'IconGlobe',
                      },
                      {
                        value: 'CSV',
                        label: 'CSV',
                        iconName: 'IconCodeSquare',
                      },
                      {
                        value: 'Text',
                        label: 'Text',
                        iconName: 'IconFile',
                      },
                      {
                        value: 'Excel95',
                        label: 'Excel 95 +',
                        iconName: 'IconBarChartCircle',
                      },
                      {
                        value: 'Excel2007',
                        label: 'Excel 2007 +',
                        iconName: 'IconBarChartSquare',
                      },
                    ]}
                  />
                </div>
                <div className="w-full">
                  <button
                    onClick={() => {
                      if (
                        fileType == 'CSV' ||
                        fileType == 'Text' ||
                        fileType == 'HTML' ||
                        fileType == 'Excel95' ||
                        fileType == 'Excel2007'
                      )
                        setIsConfrim(!isConfrim)
                    }}
                    className=" bg-bluishGreen text-white min-h-[48px] w-[98%] font-medium rounded-[72px] text-[14px]  "
                  >
                    Export Data
                  </button>
                </div>
              </div>
            )}
          </Modal>
          {/************************************* Filter modal ************************************/}
        </div>
      )}
      {isView == 'user-view' && (
        <UserView
          recordId={id}
          schoolData={schoolItemId}
          setIsView={setIsView}
          rolesData={rolesData || []}
        />
      )}
      <Modal
        customStyle={{ borderRadius: 16, padding: '16px 8px', width: '480px' }}
        isOpen={isExportOpen}
        onClose={handleExportCloseModal}
      >
        {isConfrim ? (
          <div
            className={
              'max-h-[100vh] custom-scrollbar items-center flex flex-col gap-4 py-4 px-8'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-lg font-bold leading-6'}>
                Export Data
              </h1>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 text-center'
                }
              >
                The CSV export file will be generated for download. Disable any
                popup blockers in your browser to ensure proper download.{' '}
                <span className="mt-3">Ok to proceed?</span>
              </p>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 mt-4 text-center'
                }
              >
                Ok to proceed?
              </p>
            </div>
            <div className="w-full flex flex-col gap-2 mt-2">
              {(fileType == 'Excel95' || fileType == 'Excel2007') && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    const { data } = ComputeData(
                      scrRecords?.data?.data || [],
                      selectedValues
                    )

                    if (data.length) {
                      exportToExcel(data, 'data', fileType)
                    }

                    // exportToExcel(scrRecords?.data?.data, 'data', fileType)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                    setSelectedValues([])
                  }}
                />
              )}
              {fileType == 'HTML' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    const { all_selected, data } = ComputeData(
                      scrRecords?.data?.data || [],
                      selectedValues
                    )

                    const columns: { title: string; column: string }[] = []

                    all_selected.forEach((val) => {
                      columns.push({ title: val, column: val })
                    })

                    const html = UIExportHtmlTable({
                      columns,
                      data,
                    })
                    if (html) {
                      handleDownloadHtml(html)
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                      setSelectedValues([])
                    }
                  }}
                />
              )}
              {fileType == 'Text' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    const { data } = ComputeData(
                      scrRecords?.data?.data || [],
                      selectedValues
                    )

                    handleDownloadTxt(data)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                    setSelectedValues([])
                  }}
                />
              )}
              {fileType == 'CSV' && (
                <CSVLink
                  target="_blank"
                  filename={'data.csv'}
                  headers={(() => {
                    const { all_selected } = ComputeData(
                      scrRecords?.data?.data || [],
                      selectedValues
                    )

                    const headers: {
                      key: string
                      label: string
                    }[] = []

                    all_selected.forEach((val) => {
                      headers.push({ key: val, label: val })
                    })

                    return headers
                  })()}
                  data={(() => {
                    const { data } = ComputeData(
                      scrRecords?.data?.data || [],
                      selectedValues
                    )

                    return data
                  })()}
                >
                  <UIButton
                    label="Confirm"
                    onClick={() => {
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                      setSelectedValues([])
                    }}
                  />
                </CSVLink>
              )}
              <UIButton
                secondary
                label="Cancel"
                onClick={() => setIsConfrim(!isConfrim)}
              />
            </div>
          </div>
        ) : (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Export Data
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Please choose the data you want to export and file type.
              </p>
            </div>
            <div className="w-[420px] flex-col flex gap-4 my-[15px]">
              <UIMultiSelect
                options={EXPORT_CATEGORIES}
                title={'Select Categories'}
                value={selectedValues}
                onChange={handleSelectionChange}
              />
              <UiSelect
                title={'Choose Filetype'}
                placeholder="Please specify"
                labelClass={'text-xs'}
                onChange={(value) => setFileType(value)}
                selectedOptionClass={
                  'text-sm font-semibold leading-6 text-text4'
                }
                options={[
                  {
                    value: 'HTML',
                    label: 'HTML',
                    iconName: 'IconGlobe',
                  },
                  {
                    value: 'CSV',
                    label: 'CSV',
                    iconName: 'IconCodeSquare',
                  },
                  {
                    value: 'Text',
                    label: 'Text',
                    iconName: 'IconFile',
                  },
                  {
                    value: 'Excel95',
                    label: 'Excel 95 +',
                    iconName: 'IconBarChartCircle',
                  },
                  {
                    value: 'Excel2007',
                    label: 'Excel 2007 +',
                    iconName: 'IconBarChartSquare',
                  },
                ]}
              />
            </div>
            <div className="w-full">
              <button
                onClick={() => {
                  if (
                    fileType == 'CSV' ||
                    fileType == 'Text' ||
                    fileType == 'HTML' ||
                    fileType == 'Excel95' ||
                    fileType == 'Excel2007'
                  )
                    setIsConfrim(!isConfrim)
                }}
                className=" bg-bluishGreen text-white min-h-[48px] w-[98%] font-medium rounded-[72px] text-[14px]  "
              >
                Export Data
              </button>
            </div>
          </div>
        )}
      </Modal>
    </>
  )
}

export default CenteralRecords
